import React, {Component, useState} from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import {DatePicker} from '@material-ui/pickers'
import moment from 'moment'

import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'

import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import {makeStyles} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import NavigationIcon from '@material-ui/icons/Navigation'
import clsx from 'clsx'
import purple from '@material-ui/core/colors/purple'
import red from '@material-ui/core/colors/red'
import green from '@material-ui/core/colors/green'
import blue from '@material-ui/core/colors/blue'

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    // backgroundColor: 'blue',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  timeAvailable: {
    backgroundColor: green[500],
  },
  timeUnavailable: {
    backgroundColor: red[500],
  },
  myTime: {
    backgroundColor: blue[500],
  },
  selectedTime: {
    backgroundColor: blue[500],
  },
  tableRow: {
    '&:hover': {
      // backgroundColor: 'blue !important',
      // filter: 'brightness(5%)',
      // backdropFilter: 'brightness(5%)',
      backgroundColor: `${blue[100]} !important`,
    },
    '&:selected': {
      // backgroundColor: 'blue !important',
      // filter: 'brightness(5%)',
      // backdropFilter: 'brightness(5%)',
      backgroundColor: `${red[100]} !important`,
    },
    selected: {
      // backgroundColor: 'blue !important',
      // filter: 'brightness(5%)',
      // backdropFilter: 'brightness(5%)',
      backgroundColor: `${red[100]} !important`,
    },
  },
  fab: {
    margin: 0,
    top: 'auto',
    left: 20,
    bottom: 20,
    right: 'auto',
    position: 'fixed',
  },
  fabRight: {
    margin: 0,
    top: 'auto',
    left: 'auto',
    bottom: 20,
    right: 20,
    position: 'fixed',
  },
}))

// We don't want to display times between midnight and 8am, we can assume there is always space at those hours.
let timeSlots = [...Array(24).keys()]
  .filter(v => v > 7)
  .map(hour => {
    let display =
      hour.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) + ':00'
    let display30 =
      hour.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) + ':30'
    return [
      {hour: hour, minute: 0, display: display},
      {hour: hour, minute: 30, display: display30},
    ]
  })
  .flat()

let emptyTimeHash = {}
timeSlots.forEach(ts => {
  emptyTimeHash[ts.display] = {numGuests: 0, guests: []}
})

const maxGuests = 5

export default function reservation(props) {
  console.info('SHOWING reservation')
  const classes = useStyles()
  const start = moment()
  start.hour(0)
  start.second(0)
  start.minute(0)

  const [startDate, handleStartDateChange] = useState(start)
  const [selectedTimes, setSelectedTimes] = useState({})
  const [reservations, setReservations] = useState([])
  const [timeHash, setTimeHash] = useState(emptyTimeHash)
  const [membership, setMembership] = useState()
  const [reservation, setReservation] = useState()
  const [user, setUser] = useState()
  const [myReservation, setMyReservation] = useState()
  const [boolReserveEntireGym, setBoolReserveEntireGym] = useState(false)
  const [myReservationTimeSlots, setMyReservationTimeSlots] = useState([])

  React.useEffect(() => {
    let userListener, reservationListener, collectionRef
    let data = []
    const fetchData = async () => {
      let endDate = moment(startDate).add(1, 'days')

      let userId = window.firebaseApp.auth().getUid()
      let user =
        userId &&
        (await window.firebaseDb.collection('users').doc(userId).get()).data()
      let membership =
        userId &&
        (await (await window.firebaseDb.collection('memberships'))
          .where('userId', '==', userId)
          .get())
      membership = membership && !membership.empty && membership.docs[0].data()

      if (!membership) {
        console.info('you need to be a member to make reservations')
      }
      setUser(user)
      setMembership(membership)

      collectionRef = window.firebaseDb
        .collection('reservations')
        .where('start', '>', startDate.toDate())
        .where('start', '<', endDate.toDate())
        .where('gymId', '==', props.gym.id)

      reservationListener = collectionRef.onSnapshot(collectionSnapshot => {
        data = collectionSnapshot.docs.map(function (documentSnapshot) {
          return Object.assign({}, documentSnapshot.data(), {
            key: documentSnapshot.id,
          })
        })
        console.info('Reservation data:')
        console.info(data)
        setReservations(data)
        let myReservation = undefined
        if(user){
          myReservation = data.filter(r => r.userId === user.uid)[0]
        }
        let myReservationTimeSlots = []

        if (myReservation) {
          myReservationTimeSlots = getReservationTimeSlots(myReservation)
        }
        setMyReservation(myReservation)
        setMyReservationTimeSlots(myReservationTimeSlots)
        calculateAvailability(data)
      })
    }
    fetchData()
    return () => {
      console.info('cleaning up reservations')
      userListener && userListener()
      reservationListener && reservationListener()
    }
  }, [startDate])

  const getTimeSlotRange = (startSlot, endSlot) => {
    return timeSlots.filter(ts => {
      let isAtOrAfterStart =
        ts.hour > startSlot.hour
          ? true
          : ts.hour === startSlot.hour && ts.minute >= startSlot.minute
      let isBeforeEnd =
        ts.hour < endSlot.hour
          ? true
          : ts.hour === endSlot.hour && ts.minute < endSlot.minute
      return isAtOrAfterStart && isBeforeEnd
    })
  }

  const getReservationTimeSlots = reservation => {
    let rStart = moment(reservation.start * 1000)
    let rEnd = moment(reservation.end * 1000)
    let startHour = rStart.hours()
    let endHour = rEnd.hours()
    let startMinute = rStart.minutes()
    let endMinute = rEnd.minutes()

    let startSlot = {hour: startHour, minute: startMinute}
    let endSlot = {hour: endHour, minute: endMinute}
    return getTimeSlotRange(startSlot, endSlot)
  }

  const calculateAvailability = reservations => {
    let newTimeHash = {}
    timeSlots.forEach(ts => {
      newTimeHash[ts.display] = {numGuests: 0, guests: []}
    })
    reservations.map(reservation => {
      let timeSlotRange = getReservationTimeSlots(reservation)
      timeSlotRange.forEach(ts => {
        newTimeHash[ts.display].numGuests = reservation.entireGym
          ? maxGuests
          : newTimeHash[ts.display].numGuests + 1
        newTimeHash[ts.display].guests = newTimeHash[ts.display].guests.concat(
          reservation.userName,
        )
      })
    })
    console.info('TIMEHASH:')
    console.info(newTimeHash)
    setTimeHash(newTimeHash)
  }

  const onSave = async () => {
    let startTime
    let endTime
    let inDuration = false
    let durationEnded = false
    let myReservation = reservations.filter(r => r.userId === user.uid)[0]
    timeSlots.forEach(ts => {
      if (durationEnded) {
        // do nothing
      } else if (!inDuration) {
        if (selectedTimes[ts.display]) {
          inDuration = true
          startTime = moment(startDate)
            .add(ts.hour, 'hours')
            .add(ts.minute, 'minutes')
        }
      } else {
        // check if duration has a gap, which will mark the end
        if (!selectedTimes[ts.display]) {
          durationEnded = true
          inDuration = false
          endTime = moment(startDate)
            .add(ts.hour, 'hours')
            .add(ts.minute, 'minutes')
        }
      }
    })
    let updatedReservation = {
      userId: user.uid,
      userName: user.displayName,
      start: startTime.toDate(),
      end: endTime.toDate(),
      gymId: props.gym.id,
      entireGym: boolReserveEntireGym,
    }

    if (myReservation && myReservation.key) {
      await window.firebaseDb
        .collection('reservations')
        .doc(myReservation.key)
        .set(updatedReservation)
    } else {
      await window.firebaseDb.collection('reservations').add(updatedReservation)
    }
    setSelectedTimes({})
  }

  const onCancel = async () => {
    await window.firebaseDb
      .collection('reservations')
      .doc(myReservation.key)
      .delete()

    setSelectedTimes({})
  }

  const handleClick = (event, timeSlot) => {
    let newSelectedTimes = Object.assign({}, selectedTimes)
    newSelectedTimes[timeSlot.display] = !newSelectedTimes[timeSlot.display]
    setSelectedTimes(newSelectedTimes)
  }

  const reserveEntireGym = () => {
    setBoolReserveEntireGym(!boolReserveEntireGym)
  }

  if (!membership) {
    return (
      <Grid container>
        <Typography className="black">
          You need to be a member to make reservations. Contact
          nate.jenkins@gmail.com for more information.
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper>
          <Typography>Select Date:</Typography>
          <Grid item xs={12}>
            <DatePicker
              inputVariant="filled"
              value={startDate}
              autoOk
              onChange={date => {
                let newDate = moment(date)
                newDate.hour(0)
                newDate.second(0)
                newDate.minute(0)
                handleStartDateChange(newDate)
              }}
              format="DD/MM/yyyy"
            />
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Availability</TableCell>
                <TableCell>Climbers</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSlots.map(timeSlot => {
                let isTimeSelected = selectedTimes[timeSlot.display]
                let isTimeReservedByMe =
                  myReservationTimeSlots.filter(
                    ts => ts.display === timeSlot.display,
                  )[0] || false

                let spaceRemaining =
                  maxGuests - timeHash[timeSlot.display].numGuests
                let isAvailable = spaceRemaining > 0
                return (
                  <TableRow
                    hover
                    onClick={event => {
                      if (isAvailable) {
                        handleClick(event, timeSlot)
                      }
                    }}
                    tabIndex={-1}
                    key={timeSlot.display}
                    selected={false}
                    className={clsx(
                      classes.tableRow,
                      isAvailable
                        ? classes.timeAvailable
                        : classes.timeUnavailable,
                      isTimeReservedByMe &&
                        Object.keys(selectedTimes).length === 0 &&
                        classes.myTime,
                      isTimeSelected && classes.selectedTime,
                    )}>
                    <TableCell component="th" scope="row">
                      {timeSlot.display}
                    </TableCell>
                    <TableCell>
                      {isTimeReservedByMe ? "You're booked! " : ''}
                      {isAvailable
                        ? `${spaceRemaining} slots remaining`
                        : `booked`}
                    </TableCell>
                    <TableCell>
                      {timeHash[timeSlot.display].guests
                        .filter(name => name)
                        .join(', ')}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {Object.keys(selectedTimes).length > 0 && (
          <Fab
            onClick={onSave}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className={classes.fab}>
            <NavigationIcon className={classes.extendedIcon} />
            {myReservation &&
              Object.keys(selectedTimes).length > 0 &&
              'Update Reservation'}
            {!myReservation &&
              Object.keys(selectedTimes).length > 0 &&
              'Make Reservation'}
          </Fab>
        )}
        {myReservation && (
          <Fab
            onClick={onCancel}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className={classes.fabRight}>
            <NavigationIcon className={classes.extendedIcon} />
            Cancel Reservation
          </Fab>
        )}
        {user.admin && (
          <Fab
            onClick={reserveEntireGym}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className={classes.fabRight}>
            <NavigationIcon className={classes.extendedIcon} />
            {boolReserveEntireGym ? 'Single Booking' : 'Entire Gym'}
          </Fab>
        )}
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/reservations/Reservations.js